{
  "ui": {
    "contact": {
      "eyebrow": "KONTAKT & STANDORTE",
      "title": "Triff uns auf der Matte.",
      "copy": "Beide Dojos sind gut erreichbar. Öffne die Karte für die Anfahrt oder kontaktiere das Team vor deinem ersten Besuch.",
      "load_map": "Karte laden",
      "directions": "Route öffnen",
      "questions": "Fragen vor deinem Besuch?"
    },
    "nav": {
      "programs": "Programme",
      "dojos": "Dojos",
      "schedule": "Trainingsplan",
      "pricing": "Preise",
      "team": "Team",
      "news": "News",
      "contact": "Kontakt",
      "trial": "Probetraining"
    },
    "dojos": {
      "eyebrow": "ZWEI DOJOS · EIN TEAM",
      "title": "Dein Ort zum Trainieren.",
      "copy": "Wähle den Standort, der zu deinem Alltag passt. Trainingsphilosophie und Teamgeist begleiten dich.",
      "schedule": "Trainingsplan ansehen",
      "map": "Karte öffnen",
      "rules": "Dojo Rules ansehen"
    },
    "form": {
      "optional": "optional",
      "success": "Vielen Dank. Deine Anfrage wurde gesendet.",
      "program": "Programm",
      "message": "Nachricht",
      "name": "Name",
      "phone": "Telefon",
      "dojo": "Dojo",
      "placeholder": "Erzähle uns kurz von deiner Erfahrung oder deinem bevorzugten Trainingstag.",
      "mail": "Dein E-Mail-Programm wird mit der vorbereiteten Anfrage geöffnet.",
      "email": "E-Mail"
    },
    "pricing": {
      "options": "Angebote",
      "option": "Angebot",
      "best": "Bestes Preis-Leistungs-Verhältnis",
      "choose": "Mitgliedschaft wählen",
      "ask": "Dieses Angebot anfragen",
      "save": "Spare"
    },
    "programs": {
      "eyebrow": "FINDE DEIN TRAINING",
      "title": "Ein Programm für jeden Einstieg.",
      "copy": "Von der ersten Rolle bis zum Wettkampfpodest: Jede Gruppe erhält fokussiertes Coaching und einen klaren Weg nach vorne.",
      "classes": "Passende Klassen anzeigen"
    },
    "instagram": {
      "live": "LIVE VON INSTAGRAM",
      "follow": "FOLGE DEM TEAM",
      "view": "Beitrag ansehen"
    },
    "mobile_cta": "Probetraining buchen",
    "news": {
      "eyebrow": "TEAM-NEWS",
      "title": "Neuigkeiten aus den Dojos.",
      "copy": "Änderungen im Trainingsplan, Camps, Seminare und Geschichten aus der Community – alle wichtigen Updates findest du hier.",
      "read": "Beitrag lesen",
      "archive": "Vergangene News",
      "close": "News-Beitrag schliessen"
    },
    "faq": {
      "eyebrow": "GUT ZU WISSEN",
      "title": "Fragen vor deiner ersten Rolle?",
      "copy": "Klare Antworten auf die häufigsten Fragen von neuen Mitgliedern und Eltern."
    },
    "days": {
      "monday": "Mo",
      "tuesday": "Di",
      "wednesday": "Mi",
      "thursday": "Do",
      "friday": "Fr",
      "saturday": "Sa",
      "sunday": "So"
    },
    "schedule": {
      "footnote": "Während Ferien und Wettkampfperioden kann sich der Trainingsplan ändern. Beachte den Hinweis oder kontaktiere im Zweifelsfall das Team.",
      "all": "Alle Klassen",
      "mma": "MMA",
      "today": "Heute",
      "level": "LEVEL / GRUPPE",
      "empty_title": "An diesem Tag gibt es keine passende Klasse.",
      "empty_copy": "Wähle einen anderen Tag oder zeige alle Klassen an.",
      "eyebrow": "DIESE WOCHE AUF DER MATTE",
      "open": "Offen",
      "kids": "Kinder",
      "beginner": "Für Anfänger geeignet",
      "copy": "Filtere nach Dojo, Wochentag und Zielgruppe. Zeiten und Klassendetails werden für jeden Standort separat gepflegt.",
      "title": "Finde deine nächste Klasse.",
      "adults": "Erwachsene",
      "coach": "COACH",
      "women": "Frauen",
      "show_all": "Alle Klassen anzeigen"
    },
    "hero": {
      "trial": "Probetraining buchen",
      "schedule": "Trainingsplan ansehen",
      "locations": "Unsere Standorte"
    },
    "video": {
      "play": "Video abspielen"
    },
    "footer": {
      "instagram": "Instagram",
      "schedule": "Trainingsplan",
      "trial": "Probetraining",
      "member": "Member-Login",
      "rules": "Dojo Rules"
    },
    "skip": "Zum Inhalt springen"
  },
  "site": {
    "contact": {
      "eyebrow": "DEIN PROBETRAINING",
      "title": "Komm, wie du bist.",
      "body": "Sag uns, welches Dojo und welches Programm dich interessieren. Wir helfen dir bei der Wahl der passenden Klasse und erklären, was du mitbringen sollst.",
      "button": "Probetraining anfragen"
    },
    "dojos": [
      {
        "description": "Unser ursprüngliches Dojo: mehr als 25 Lektionen pro Woche, ein multikulturelles Team und Programme vom ersten Training bis zur Wettkampfvorbereitung.",
        "detail": "Gi · No-Gi · MMA · Kids · Women"
      },
      {
        "description": "Ein einladendes, familienfreundliches Dojo an der Silver Coast mit fokussierten Klassen für Kinder, Erwachsene und Frauen.",
        "detail": "Gi · Kids · Women · Erwachsene"
      }
    ],
    "announcement": "Neuer Stundenplan ab 17. August: über 45 Lektionen pro Woche in Zürich & Thalwil",
    "coaches": [
      {
        "name": "Tiago De Paula",
        "belt": "Black Belt",
        "roles": "Gründer · Head Coach",
        "bio": "Tiago erhielt 2022 seinen Black Belt unter Carlson Gracie Zurich. Seit seinem Einstieg ins BJJ im Jahr 2013 hat er sich zu einem engagierten Coach für Kinder und Erwachsene entwickelt. Mit seiner offenen Art, seinem kontinuierlichen Lernwillen und seiner Fähigkeit, andere zu motivieren, ist er eine inspirierende Führungspersönlichkeit der Community. Tiago ermutigt alle Schülerinnen und Schüler, dranzubleiben und sich auf und neben der Matte weiterzuentwickeln."
      },
      {
        "name": "Luiz Finocchio",
        "belt": "Black Belt",
        "roles": "Head Coach · BJJ · MMA Coach",
        "bio": "Luiz ist BJJ Black Belt, professioneller Wettkämpfer, Grappling-Coach und ehemaliger ungeschlagener MMA-Profi mit einer Bilanz von 3–0. Er ist für seine technische Präzision und seine detaillierte Vermittlung bekannt, startete unter anderem bei Polaris, dem BJJ Grand Prix und IBJJF-Turnieren und gibt international Seminare. Bei Tiago de Paula BJJ bringt Luiz seine Erfahrung auf höchstem Niveau in das BJJ- und MMA-Training ein."
      },
      {
        "name": "Pedro Ledermann",
        "belt": "Black Belt",
        "roles": "BJJ · Adults & Kids Coach",
        "bio": "Pedro ist Black Belt unter Marko Leisten und trainiert seit 2012 Brazilian Jiu-Jitsu. 2021 wurde er Vollzeit-Coach und begann seine Lehrtätigkeit bei Tiago de Paula BJJ. Mit seiner Geduld und seiner Gelassenheit im lebhaften Trainingsalltag ist er wie geschaffen für das Kids-Training – frag ihn nach dem «Takedown Spiel». In den Erwachsenenklassen legt Pedro den Fokus auf Bewegung und Verteidigung: «Ein bewegliches Ziel ist schwer zu submitten.»"
      },
      {
        "name": "Hian Finocchio",
        "belt": "Brown Belt",
        "roles": "BJJ · Adults & Kids Coach",
        "bio": "Hian ist ein engagierter Brazilian-Jiu-Jitsu-Brown-Belt unter Luiz Finocchio und widmet sich mit grosser Leidenschaft der Entwicklung junger Talente. Als spezialisierter Kids-Coach hat er zahlreiche erfolgreiche Nachwuchs-Wettkämpferinnen und -Wettkämpfer begleitet. Dabei vermittelt er der nächsten Generation Disziplin, solide Technik und ein selbstbewusstes Wettkampf-Mindset."
      }
    ],
    "intro": {
      "eyebrow": "WILLKOMMEN IM TEAM",
      "title": "Ernsthaftes Training. Familiäre Atmosphäre.",
      "body": "Tiago de Paula BJJ wurde 2017 in Zürich gegründet und bringt Anfänger, Wettkämpfer, Kinder und Familien zusammen. Jede Klasse hilft dir, dich besser zu bewegen, unter Druck ruhig zu bleiben und mit einem Team zu wachsen, das dich unterstützt.",
      "quote": "Du musst nicht fit sein, um anzufangen. Du fängst an – und wir bauen darauf auf."
    },
    "programs": [
      {
        "title": "BJJ für Erwachsene",
        "tag": "GI · NO-GI",
        "description": "Strukturierte Klassen vom ersten Training bis zum fortgeschrittenen Niveau – mit klaren technischen Progressionen und genügend Zeit für Live-Training."
      },
      {
        "title": "Kinder & Jugendliche",
        "tag": "AB 3 JAHREN",
        "description": "Altersgerechte Gruppen fördern Selbstvertrauen, Koordination, Disziplin und echte Freundschaften in einem sicheren, spielerischen Umfeld."
      },
      {
        "title": "Women Only",
        "tag": "ANFÄNGERFREUNDLICH",
        "description": "Ein fokussiertes Training nur für Frauen, um praxisnahes BJJ zu lernen, Selbstvertrauen aufzubauen und im eigenen Tempo Fortschritte zu machen."
      },
      {
        "title": "MMA & Competition",
        "tag": "NEXT LEVEL",
        "description": "Spezifische Einheiten für alle, die Wrestling, Striking, No-Gi und ihre Wettkampfvorbereitung weiterentwickeln wollen."
      }
    ],
    "coaches_intro": {
      "eyebrow": "LERNE DAS TEAM KENNEN",
      "title": "Coaches, die dich weiterbringen.",
      "intro": "Erfahrene Kampfsportler, aufmerksame Lehrer und ein gemeinsamer Qualitätsanspruch auf jeder Matte."
    },
    "hero": {
      "eyebrow": "BJJ · MMA · COMMUNITY",
      "title": "Stärker auf der Matte.",
      "title_accent": "Besser darüber hinaus.",
      "intro": "Brazilian Jiu-Jitsu für Erwachsene, Kinder und Frauen – mit Ambition, Sorgfalt und brasilianischer Energie in Zürich und Thalwil.",
      "image_alt": "Brazilian-Jiu-Jitsu-Training bei Tiago de Paula BJJ"
    },
    "first_visit": {
      "eyebrow": "DEINE ERSTE STUNDE",
      "title": "Starte ohne Druck.",
      "intro": "Du brauchst weder Erfahrung noch ein besonderes Fitnessniveau. Wir helfen dir, die passende Klasse zu wählen, und erklären dir genau, was dich erwartet.",
      "steps": [
        {
          "title": "Wähle dein Dojo",
          "text": "Entscheide dich für Zürich oder Thalwil und teile uns mit, welches Programm dich interessiert."
        },
        {
          "title": "Einfache Sportkleidung genügt",
          "text": "Für die erste Stunde reichen bequeme Sportkleidung und eine Wasserflasche. Alles Weitere erklären wir dir."
        },
        {
          "title": "Lerne das Team kennen",
          "text": "Komme einige Minuten früher. Ein Coach begrüsst dich und begleitet dich durch das Training."
        }
      ]
    },
    "stats": [
      {
        "label": "Dojos"
      },
      {
        "label": "Klassen pro Woche"
      },
      {
        "label": "Mitglieder"
      },
      {
        "label": "Gründung in Zürich"
      }
    ]
  },
  "pricing": {
    "eyebrow": "ABOS & TRAINING",
    "heading": "Wähle dein Training.",
    "intro": "Klare Abos für BJJ – Gi & No-Gi, All Access, MMA & Striking sowie Privatlektionen.",
    "note": "Preise in CHF. Für das Abo «Jugendliche, Lernende & Studierende» ist ein gültiger Schüler-, Lehrlings- oder Studierendenausweis erforderlich. Wird ein Mitglied während eines laufenden Abos 14 oder 26 Jahre alt, gilt der bisherige Tarif bis zur nächsten Verlängerung. Leistungen und Verfügbarkeit können je nach Dojo variieren. Kontaktiere das Team, wenn du unsicher bist, welches Angebot passt.",
    "categories": [
      {
        "label": "BJJ für Frauen",
        "description": "BJJ – Gi & No-Gi in speziellen Klassen nur für Frauen."
      },
      {
        "label": "Erwachsene",
        "description": "Wähle BJJ – Gi & No-Gi oder All Access mit BJJ, MMA und Striking – Kickboxen/Muay Thai. Für Erwachsene ab 18 Jahren."
      },
      {
        "label": "Kinder-BJJ",
        "description": "BJJ – Gi & No-Gi für Kinder bis einschliesslich 13 Jahre."
      },
      {
        "label": "Jugendliche & Studierende",
        "description": "All Access für 14- bis 25-Jährige, Lernende und Studierende: BJJ, MMA und Striking – Kickboxen/Muay Thai. Gültiger Ausweis erforderlich."
      },
      {
        "label": "Privatlektionen",
        "description": "Einzel-, Duo- und Kleingruppentraining sowie Gast-Tagespass."
      },
      {
        "label": "MMA & Striking",
        "description": "Nur MMA, Kickboxen und Muay Thai."
      }
    ],
    "plans": [
      {
        "name": "BJJ für Frauen",
        "duration": "12 Monate",
        "frequency": "Women-only Klassen in Gi & No-Gi",
        "description": "Jahresabo für das spezielle BJJ-Programm nur für Frauen."
      },
      {
        "name": "BJJ für Frauen",
        "duration": "6 Monate",
        "frequency": "Women-only Klassen in Gi & No-Gi",
        "description": "Sechs Monate Zugang zum speziellen BJJ-Programm nur für Frauen."
      },
      {
        "name": "BJJ für Erwachsene – ab 18 Jahren",
        "duration": "12 Monate",
        "frequency": "Unbegrenzte Gi- und No-Gi-Klassen",
        "description": "Ein volles Jahr reguläres BJJ-Training für Erwachsene."
      },
      {
        "name": "BJJ für Erwachsene – ab 18 Jahren",
        "duration": "6 Monate",
        "frequency": "Unbegrenzte Gi- und No-Gi-Klassen",
        "description": "Sechs Monate reguläres BJJ-Training für Erwachsene."
      },
      {
        "name": "All Access für Erwachsene – ab 18 Jahren",
        "duration": "12 Monate",
        "frequency": "Unbegrenztes BJJ-, MMA- und Striking-Training",
        "description": "Beinhaltet BJJ, MMA und Striking – Kickboxen/Muay Thai."
      },
      {
        "name": "All Access für Erwachsene – ab 18 Jahren",
        "duration": "6 Monate",
        "frequency": "Unbegrenztes BJJ-, MMA- und Striking-Training",
        "description": "Beinhaltet BJJ, MMA und Striking – Kickboxen/Muay Thai."
      },
      {
        "name": "Kinder-BJJ – 1–2 Trainings pro Woche",
        "duration": "12 Monate",
        "frequency": "Bis einschliesslich 13 Jahre",
        "description": "Ein bis zwei altersgerechte BJJ-Trainings pro Woche."
      },
      {
        "name": "Kinder-BJJ – 1–2 Trainings pro Woche",
        "duration": "6 Monate",
        "frequency": "Bis einschliesslich 13 Jahre",
        "description": "Ein bis zwei altersgerechte BJJ-Trainings pro Woche."
      },
      {
        "name": "Kinder-BJJ Unlimited",
        "duration": "12 Monate",
        "frequency": "Bis einschliesslich 13 Jahre",
        "description": "Unbegrenzter Zugang zum altersgerechten Kinder-BJJ-Programm."
      },
      {
        "name": "Kinder-BJJ Unlimited",
        "duration": "6 Monate",
        "frequency": "Bis einschliesslich 13 Jahre",
        "description": "Unbegrenzter Zugang zum altersgerechten Kinder-BJJ-Programm."
      },
      {
        "name": "Jugendliche, Lernende & Studierende – 14–25 Jahre",
        "duration": "12 Monate",
        "frequency": "Gültiger Ausweis erforderlich",
        "description": "All Access: BJJ, MMA und Striking – Kickboxen/Muay Thai."
      },
      {
        "name": "Jugendliche, Lernende & Studierende – 14–25 Jahre",
        "duration": "6 Monate",
        "frequency": "Gültiger Ausweis erforderlich",
        "description": "All Access: BJJ, MMA und Striking – Kickboxen/Muay Thai."
      },
      {
        "name": "Privatlektion – Einzelperson",
        "duration": "1 Lektion",
        "frequency": "Individuelles Coaching",
        "description": "Eine private BJJ- oder MMA-Lektion für CHF 150 pro Stunde."
      },
      {
        "name": "Privatlektionen-Paket – Einzelperson",
        "duration": "10 Lektionen",
        "frequency": "Individuelles Coaching",
        "description": "Zehn individuell abgestimmte private BJJ- oder MMA-Lektionen."
      },
      {
        "name": "Privatlektionen-Paket – zwei Personen",
        "duration": "10 Lektionen",
        "frequency": "Gemeinsames Privattraining",
        "description": "Zehn private BJJ- oder MMA-Lektionen für zwei Personen."
      },
      {
        "name": "Privatlektionen-Paket – drei bis fünf Personen",
        "duration": "10 Lektionen",
        "frequency": "Coaching in der Kleingruppe",
        "description": "Zehn private BJJ- oder MMA-Lektionen für eine Gruppe von drei bis fünf Personen."
      },
      {
        "name": "Gast-Tagespass",
        "duration": "1 Tag",
        "frequency": "Einmaliger Zugang",
        "description": "Ein Trainingstag als Gast."
      },
      {
        "name": "Nur MMA & Striking",
        "duration": "12 Monate",
        "frequency": "Unbegrenztes MMA-, Kickbox- und Muay-Thai-Training",
        "description": "Jahresabo für das MMA-&-Striking-Programm."
      },
      {
        "name": "Nur MMA & Striking",
        "duration": "6 Monate",
        "frequency": "Unbegrenztes MMA-, Kickbox- und Muay-Thai-Training",
        "description": "Sechs Monate Zugang zum MMA-&-Striking-Programm."
      }
    ]
  },
  "video": {
    "eyebrow": "IM DOJO",
    "heading": "So trainieren wir.",
    "intro": "Technik, Intensität und die Energie eines Teams, das gemeinsam lernt. Erlebe die Atmosphäre auf der Matte schon vor deinem ersten Training.",
    "embed_title": "Trainingsvideo von Tiago de Paula BJJ",
    "caption": "No-Gi-Training und Workshops in Zürich",
    "cta_label": "Mehr Videos auf Instagram"
  },
  "instagram": {
    "heading": "Direkt von der Matte",
    "intro": "Training, Wettkämpfe und der Alltag im Team – folge uns auf Instagram."
  },
  "schedules": {
    "zurich_notice": "",
    "silver_notice": "Sommerpause bis 17. August. Danach gilt wieder der reguläre Trainingsplan.",
    "titles": {
      "Kids 3": "Kids 3",
      "Adults No-Gi": "No-Gi für Erwachsene",
      "Open Mat": "Open Mat",
      "Juniors MMA": "Juniors MMA",
      "Kids Competition": "Kids Competition",
      "Women Only": "Women Only",
      "Girls Only": "Girls Only",
      "Kids 3 / Juniors": "Kids 3 / Juniors",
      "Kids 3 / Juniors MMA": "Kids 3 / Juniors MMA",
      "Kids 3 / Junior MMA": "Kids 3 / Junior MMA",
      "Adults BJJ": "BJJ für Erwachsene",
      "Adults No-Gi — Beginners": "No-Gi für Erwachsene – Anfänger",
      "Kids 1": "Kids 1",
      "Kids 2": "Kids 2",
      "MMA / Striking": "MMA / Striking"
    },
    "levels": {
      "Beginners": "Anfänger",
      "Ages 9–12": "9–12 Jahre",
      "Ages 9–13": "9–13 Jahre",
      "Ages 7–12": "7–12 Jahre",
      "Ages 3–5": "3–5 Jahre",
      "All levels": "Alle Levels",
      "Ages 6–8": "6–8 Jahre",
      "Ages 4–12 · 45 min": "4–12 Jahre · 45 Min.",
      "Ages 4–6 · 45 min": "4–6 Jahre · 45 Min.",
      "Invitation / advanced": "Auf Einladung / Fortgeschritten"
    }
  },
  "news": {
    "2026-08-02-michael-adcc-vip-pass": {
      "title": "Vom Helfereinsatz nach Krakau: Michael gewinnt den ADCC VIP-Pass",
      "category": "Community",
      "excerpt": "Unser treuer «Old Guard»-Athlet Michael M. gewinnt einen VIP-Zweitagespass für die ADCC Pro World Championship in Krakau.",
      "body": "Unsere nationalen Wettkämpfe wären ohne all die Menschen nicht möglich, die hinter den Kulissen ihre Zeit, Energie und ihr Engagement einbringen. Als besonderes Dankeschön konnten wir dieses Jahr unter allen Helferinnen und Helfern einen unglaublichen Preis verlosen: einen VIP-Zweitagespass für die ADCC Pro World Championship in Krakau.\n\nDer glückliche Gewinner ist unser treuer «Old Guard»-Athlet Michael M. Er ist der lebende Beweis dafür, dass es kein falsches Alter gibt, um mit Brazilian Jiu-Jitsu zu beginnen. Entscheidend sind der Mut, den ersten Schritt zu machen, die Beständigkeit, immer wieder ins Training zu kommen, und die Bereitschaft, mit jeder Einheit weiterzulernen.\n\nHerzlichen Glückwunsch, Michael! Wir wünschen dir ein unvergessliches Wochenende in Krakau. Geniesse die Kämpfe, feuere unser Team kräftig an – und bring uns unbedingt ein paar neue Techniken mit. Wir werden genau hinschauen. ;-) Oss!"
    },
    "2026-08-02-luiz-adcc-krakow": {
      "title": "Coach Luiz tritt bei der ADCC World Championship an",
      "category": "Wettkampf",
      "excerpt": "Von unseren Matten auf eine der grössten Bühnen des Grapplings: Coach Luiz Finocchio startet bei der ADCC World Championship in Krakau.",
      "body": "Eine der grössten Bühnen des Grapplings ruft: Unser Coach Luiz Finocchio wird bei der ADCC World Championship in Krakau als Athlet antreten.\n\nLuiz bringt in den Wettkampf genau das mit, was er unserem Team jeden Tag vermittelt – technische Präzision, Mut unter Druck und den unbedingten Willen, sich ständig weiterzuentwickeln. Bei Tiago de Paula BJJ sind wir überzeugt: Die stärksten Athleten hören niemals auf, Schüler zu sein. Luiz verkörpert diese Philosophie jedes Mal, wenn er die Matte betritt – als Coach ebenso wie als Wettkämpfer.\n\nDas gesamte Team steht hinter dir, Luiz. Vertraue auf dein Game, nimm die Herausforderung an und zeige Krakau, was du dir über Jahre harter Arbeit aufgebaut hast. Ein Team. Ein Kampf. Oss!"
    },
    "2026-08-02-kids-summer-bjj-camp": {
      "title": "Kids Summer BJJ Camp in Zürich",
      "category": "Camp",
      "excerpt": "Fünf Vormittage voller BJJ, Bewegung und Spass vom 10. bis 14. August – die Anmeldung ist noch bis zum 7. August möglich.",
      "body": "Vom 10. bis 14. August 2026 erwarten die Kinder in unserem Kids Summer BJJ Camp fünf Vormittage voller Training, Bewegung und Spass im Zürich Dojo an der Forchstrasse 225. Das Camp findet täglich von 9.00 bis 12.00 Uhr statt und wird im No-Gi trainiert.\n\nDie gesamte Camp-Woche kostet CHF 250. Einzelne Tage können für CHF 70 pro Tag gebucht werden. Getränke und Snacks sind inbegriffen, und zum Abschluss der Woche feiern wir am Freitag gemeinsam eine Pizza-Party.\n\nDie Platzzahl ist begrenzt und Anmeldungen sind noch bis zum 7. August möglich. Kontaktiert das Team direkt, um eurem Kind einen Platz zu sichern. Rollen, lernen und gemeinsam Spass haben. Oss!"
    },
    "2026-08-02-emilian-gold-barcelona": {
      "title": "Gold für Emilian in Barcelona",
      "category": "Wettkampf",
      "excerpt": "Unser junger Athlet Emilian gewinnt an den FIJJD International Championship 2026 in Barcelona Gold in seiner Kategorie.",
      "body": "Unser junger Athlet Emilian sicherte sich an den FIJJD International Championship 2026 in Barcelona die Goldmedaille in seiner Kategorie. Unter der Betreuung von Coach Tiago zeigte er in einem packenden Kampf eine konzentrierte und entschlossene Leistung und erkämpfte sich verdient den obersten Platz auf dem Podest.\n\nDas gesamte Team von Tiago de Paula BJJ ist unglaublich stolz auf Emilian und diese grossartige Leistung. Herzlichen Glückwunsch, Champion – dein Einsatz, dein Mut und deine Disziplin haben sich ausgezahlt. Oss!"
    },
    "2026-07-18-summer-breaks": {
      "title": "Temporärer Sommer-Trainingsplan in Zürich",
      "category": "Trainingsplan",
      "excerpt": "Vom 27. Juli bis 14. August findet das reguläre Training im Zürich Dojo montags, mittwochs und freitags statt.",
      "body": "Vom 27. Juli bis 14. August findet das reguläre Erwachsenentraining im Zürich Dojo nur montags, mittwochs und freitags zu den im Trainingsplan angegebenen Zeiten statt.\n\nDie regulären Kids Classes finden vom 27. Juli bis 7. August jeweils montags, mittwochs und freitags statt. Vom 10. bis 14. August ersetzt das Kids Camp sämtliche regulären Kids Classes. In dieser Woche finden deshalb keine zusätzlichen Kids Classes statt.\n\nErwachsene können die übrigen Tage und verfügbaren Zeiten nutzen, um selbstorganisierte Open Mats durchzuführen und weiter an ihren Skills zu arbeiten. Im Silver Coast Dojo gilt ab dem 17. August wieder der reguläre Trainingsplan.\n\nVielen Dank für euer Verständnis. Wir wünschen euch einen fantastischen Sommer und sehen uns bald wieder auf der Matte. Oss!"
    },
    "2026-06-20-silver-coast": {
      "title": "Trainiere mit uns an der Silver Coast",
      "category": "Dojo",
      "excerpt": "Unser Standort in Thalwil bietet fokussierte Klassen für Kinder, Erwachsene und Frauen in einem familienfreundlichen Umfeld.",
      "body": "Das Silver Coast Dojo folgt derselben Trainingsphilosophie, die unsere Community in Zürich geprägt hat: strukturierte Klassen, persönliche Betreuung und eine einladende Atmosphäre. Entdecke den Trainingsplan für Thalwil und kontaktiere uns für deine erste Klasse."
    },
    "2026-06-01-first-class": {
      "title": "Neu im BJJ? Starte hier.",
      "category": "Academy",
      "excerpt": "Für deine erste Stunde brauchst du weder Erfahrung noch ein besonderes Fitnessniveau.",
      "body": "Wähle dein bevorzugtes Dojo und sende uns eine kurze Nachricht. Wir empfehlen dir eine anfängerfreundliche Klasse, erklären dir, was du anziehen sollst, und begrüssen dich vor Ort. Du kannst in jedem Alter anfangen und deine Fitness während des Trainings aufbauen."
    },
    "2026-08-02-emily-adcc-referee": {
      "title": "Emily als Referee bei den ADCC Amateur Worlds",
      "category": "Team",
      "excerpt": "Unsere Blue-Belt-Athletin Emily wird bei den ADCC Amateur Worlds in Krakau als Referee eingesetzt.",
      "body": "Unsere Blue-Belt-Athletin Emily hat sich als Referee bei nationalen ADCC-Turnieren mit ruhigen Entscheidungen, klarer Kommunikation und einem ausgeprägten Verständnis für den Sport Respekt und Anerkennung verdient. Nun ist ihre Berufung bestätigt: Sie wird ihre Erfahrung bei den ADCC Amateur Worlds in Krakau als Referee einbringen.\n\nBei Tiago de Paula BJJ bedeutet Entwicklung mehr als Medaillen. Athletinnen und Athleten stärken den Sport auch dann, wenn sie Verantwortung übernehmen, für Fairness sorgen und ihr Wissen auf höchstem Niveau einbringen. Emilys Berufung unterstreicht sowohl ihr persönliches Engagement als auch das Vertrauen, das sie sich in der ADCC-Community erarbeitet hat.\n\nWir sind mächtig stolz darauf, dass eine unserer Athletinnen auf einer so wichtigen internationalen Bühne geschätzt wird. Ein starkes Team bringt nicht nur Wettkämpfer hervor – es hilft dem gesamten Sport zu wachsen. Herzlichen Glückwunsch, Emily. Oss!"
    }
  }
}
